// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types } from './types';

export function utilsClear(): ReducerAction {
	return {
		type: Types.UTILS_CLEAR,
		payload: null,
	};
}
